<template>
    <div class="bar-menu">
        <button class="btn-menu" @click="ToggleMenu">
            <i class="pi pi-bars"></i>
        </button>
    </div>

    <Dialog v-model:visible="spinnervisible" modal :closable="false" class="alrt">
        <div>
            <ProgressSpinner style="width: 50px; height: 50px; display: block; margin: auto;" strokeWidth="8"
                fill="transparent" animationDuration=".5s" aria-label="Custom ProgressSpinner" />

            <p>Cerrando sesion</p>
        </div>
    </Dialog>

    <Dialog v-model:visible="visible" modal :closable="false" class="cont-30">
        <br>
        <p style="text-align: center;">¿Seguro que deseas Cerrar tu sesion?</p><br>
        <div class="container ">
            <div class="row">
                <div class="col-md-6 col-12 m-auto">
                    <button class="cont-95 d-block m-auto btn btn-danger" @click="visible = false">Cancelar</button>
                </div>
                <div class="col-md-6 col-12 m-auto">
                    <button class="cont-95 d-block m-auto btn btn-primary" @click="Logout()">Aceptar</button>
                </div>
            </div>
        </div>
        <br>
    </Dialog>

    <div class="menu" :class="{ active: openmenu === true }">
        <div class="logo-panel">
            <img src="../assets/logo.jpg" alt="Logotipo" class="logo">
        </div>
        <PanelMenu :model="items" />
        <div class="bottom-menu">
            <div class="circlename">
                <p>{{ lettercircle }}</p>
            </div>
            <p>{{ username }}</p>
            <p style="color: white; cursor: pointer; margin-top: 10px; margin-left:45%;" @click="OpenModal()">
                <i class="pi pi-sign-out"></i>
            </p>
        </div>
    </div>
</template>

<script setup>
import PanelMenu from 'primevue/panelmenu';
import {  useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';
import { Dialog, ProgressSpinner } from 'primevue';
import { getMenuItems } from '@/plugins/menu-site';

const openmenu = ref(false);
const router = useRouter();
const username = ref("");
const lettercircle = ref("");
const visible = ref(false);
var items = getMenuItems();
const spinnervisible = ref(false);


const ToggleMenu = () => {
    openmenu.value = !openmenu.value;
}


const Logout = () => {
    spinnervisible.value = true;
    localStorage.removeItem("token");
    localStorage.removeItem("id");
    localStorage.removeItem("username");
    visible.value = false;
    setTimeout(() => {
        spinnervisible.value = false;
        router.push("/");
    }, 2000);
}

const OpenModal = () => {
    visible.value = true;
    ToggleMenu();
}


onMounted(()=>{
    username.value = localStorage.getItem("nombre");
    lettercircle.value = username.value.trim()[0];
});
</script>

<style scoped>
.menu {
    width: 18%;
    min-height: 100%;
    height: 100dvh;
    background: white;
    box-shadow: 0px 4px 4px silver;
    transform: translateX(0%);
    z-index: 2000;
    position: fixed;
}

.btn-menu {
    margin-left: 95%;
    border: none;
    background-color: white;
}

.bar-menu {
    width: 100%;
    position: fixed;
    top: 0;
    background: white;
    padding: 12px;
    box-shadow: 0px 4px 4px silver;
    display: flex;
    height: 60px;
    display: none;
}

.logo-panel {
    width: 100%;
    padding: 20px;
    margin-bottom: 10px;
}

.logo {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto;
}

.bottom-menu {
    width: 100%;
    position: absolute;
    background: black;
    padding: 10px;
    bottom: 0;
    color: white;
    font-size: 0.8rem;
    display: flex;
}

.circlename {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: rgb(0, 162, 255);
    margin-top: 5px;
    margin-right: 12px;
    color: white;
    font-weight: bold;
    font-size: 1rem;
}

.circlename p {
    margin-top: 6px;
    margin-left: 10px;
}


@media(max-width:992px) {
    .menu {
        width: 90%;
        transition: .45s all;
        transform: translateX(-100%);
    }

    .active {
        transition: .45s all;
        transform: translateX(0%);
    }

    .content {
        top: 10%;
        left: 0%;
    }

    .bar-menu {
        display: block;
    }
}
</style>
